import { ClearOutlined, DeleteOutlined } from "@material-ui/icons";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import ContentHeader from "../../components/ContentHeader/ContentHeader";
import { getUrlPayment, removeCartItem } from "../../service/api/CartService";
import { Link } from "react-router-dom";
import { AddCircleOutline } from "@material-ui/icons";
import { centsToEuro } from "../../utils/numbersUtils";
import './Cart.scss';
import Spinner from "../../components/Spinner/Spinner";

const Cart = ({ items, totalPrice }) => {

    const dispatch = useDispatch();
    const [ disablePayButton, setDisablePayButton ] = useState(false);

    const handleDelete = (event, id, index) => {
        const item = items.filter((item) => item.id === id)[0];
        removeCartItem(item, dispatch);
        //dispatch(removeCartItemAction(item));
    }

    const handleClickPayment = () => {
        setDisablePayButton(true);
        getUrlPayment().then(data => {            
            window.location.replace(data.url);
        });
    }

    const renderCartTable = () => {
        return (
            <>
                <div className="container cart-container">
                    <div className="row">
                        <div className="col-12">
                            <table className="cart-table">
                                <thead>
                                    <tr>
                                        <th><DeleteOutlined/></th>
                                        <th>Identificador</th>
                                        <th>Razón social</th>
                                        <th>Coste</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items ? items.map(({ id, debtor }, index) => {
                                        return (
                                            <tr key={id}>
                                                <td className="table-cell-icon-desktop"><ClearOutlined className="delete-button" onClick={event => handleDelete(event, id, index)} /></td>
                                                <td className="table-cell-icon-mobile"><DeleteOutlined className="delete-button-mobile" onClick={event => handleDelete(event, id, index)} /></td>
                                                <td data-label="Identificador" >{debtor.identification}<div className="mobile-line-separator"></div></td>
                                                <td data-label="Razón social">{debtor.name}<div className="mobile-line-separator"></div></td>
                                                <td data-label="Coste">{centsToEuro(debtor.price)}<div className="mobile-line-separator"></div></td>
                                            </tr>
                                        )
                                    }) : null}
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4 offset-8 text-center">
                            <div className="total-cart">Total {centsToEuro(totalPrice)}€</div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 offset-xl-8 text-end button-cart-pay">
                            <button
                                onClick={!disablePayButton ? handleClickPayment : null}
                                disabled={items.length === 0 || disablePayButton}
                            >
                                {disablePayButton ? <Spinner /> : "Continuar con el pago"}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const renderEmptyCart = () => {
        return (
            <>
                <div className="container cart-container-empty">
                    <div className="row">
                        <div className="col-12">
                           <h3>En este momento no hay eGrades añadidos.</h3> 
                            <div className="button-solicitar mt-5">
                                <Link to="/search">
                                    <button><AddCircleOutline className="AddCircleOutline" /> Solicitar eGrade</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className="cart">
            <ContentHeader titulo="Carrito de compra" />
            {items.length !== 0 ? renderCartTable() : renderEmptyCart()}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        items: state.items,
        totalItems: state.totalItems,
        selecteds: state.selecteds,
        totalPrice: state.totalPrice
    }
}

export default connect(mapStateToProps)(Cart)